import axios from "axios";
// const BASE_URL = "https://ec2-54-226-41-96.compute-1.amazonaws.com";
const BASE_URL ="https://wasty-bali.onrender.com"

// -------------------------------
// 🧍 USER SIGNUP
// -------------------------------

const SHEET_WEBHOOK = "https://script.google.com/macros/s/AKfycbxYourId/exec"; // your URL

// export const logToSheet = async (data) => {
//   try {
//     await axios.post(SHEET_WEBHOOK, data);
//     console.log("✅ Logged to Google Sheet:", data.type);
//   } catch (err) {
//     console.error("❌ Logging failed:", err.message);
//   }
// };
// export const logScanTag = async (userId, qrCode, notes = "") => {
//   await logToSheet({
//     type: "scan_tag",
//     user_id: userId,
//     qr_code: qrCode,
//     notes,
//   });
// };

export const userSignup = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/signup`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Signup Error:", error.response?.data || error.message);
    throw error;
  }
};
/**
 * Posts a winner to the server
 * @param {string} phoneNumber - Winner’s phone number
 * @param {string} winnerDetails - Optional winner description/details
 * @returns {Promise<Object>} API response
 */
export const postWinner = async (phoneNumber, winnerDetails = "", type = "food", awardedDate) => {
  try {
    const payload = {
      phone_number: phoneNumber,
      winner_details: winnerDetails,
      type,
      awarded_at: awardedDate, // "YYYY-MM-DD"
    };

    const response = await axios.post(`${BASE_URL}/winner/`, payload, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    console.log("🏆 Winner posted successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error posting winner:", error.response?.data || error.message);
    throw error;
  }
};


// Example usage:
/*
const formData = new FormData();
formData.append("owner_name", "John Doe");
formData.append("shop_name", "GreenMart");
formData.append("shop_id", "GM123");
formData.append("phone_number", "9876543210");
formData.append("password", "securepass");
formData.append("photo", fileInput.files[0]);
await userSignup(formData);
*/


// -------------------------------
// 🔐 USER LOGIN
// -------------------------------
export const userLogin = async (phone_number, password) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/login`, {
      phone_number,
      password,
    });
    return response.data;
  } catch (error) {
    console.error("User Login Error:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllWinners = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/winner/winners/all`, {
      headers: {
        Accept: "application/json",
      },
    });

    console.log("🏆 All winners fetched successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching winners:", error.response?.data || error.message);
    throw error;
  }
};
// -------------------------------
// 🙋 VOLUNTEER LOGIN
// -------------------------------
export const volunteerLogin = async (name, password) => {
  try {
    const response = await axios.post(`${BASE_URL}/volunteer/login`, {
      name,
      password,
    });
    return response.data;
  } catch (error) {
    console.error("Volunteer Login Error:", error);
    throw error?.response?.data?.detail || error;
  }
};

export const fetchOwnersAPI = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/admin/owners`);
      return res.data;
    } catch (err) {
      console.error("❌ Owners Fetch Error:", err);
    } finally {
     
    }
  };
// -------------------------------
// 📝 USER FORM SUBMIT (BY VOLUNTEER)
// -------------------------------
// API wrapper
export const submitUserForm = async ({ formData, userId, score }) => {
  try {
    const payload = {
      form_details: JSON.stringify(formData),
      score: typeof score === "number" ? score : 0,
      shop_owner_id: userId,
    };

    console.log("📤 Submitting form payload:", payload);

    const response = await axios.post(`${BASE_URL}/form/`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log("✅ Form submitted successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Form Submit Error:", error.response?.data || error.message);
    throw error;
  }
};
// fetchShopList.js

export const fetchShopList = async ({
  owner_name,
  phone_number,
  shop_name,
  sort_by_score = "desc",
  date,
}) => {
  try {
    const url = `https://wasty-bali.onrender.com/admin/form/list?owner_name=${encodeURIComponent(
      owner_name
    )}&phone_number=${encodeURIComponent(
      phone_number
    )}&shop_name=${encodeURIComponent(
      shop_name
    )}&sort_by_score=${encodeURIComponent(
      sort_by_score
    )}&date=${encodeURIComponent(date)}`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: "", // empty body, as in your curl
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching shop list:", error);
    throw error;
  }
};


;


export const getUserByBarcode = async (barcodeId) => {
 try {
    const response = await axios.get(`${BASE_URL}/scan/volunteer/${barcodeId}`, {
      headers: {
        Accept: "application/json",
      },
    });

    console.log("Volunteer Data:", response.data);
    return response.data;
  } catch (error) {
    console.error("getVolunteerById Error:", error.response?.data || error.message);
    throw error;
  }
};
export const scanShop = async (shopId, qrcodeId) => {
  try {
    console.log("Scanning Shop:", { shopId, qrcodeId });
    const response = await axios.post(`${BASE_URL}/scan/shop`, {
      shop_id: shopId,
      qrcode_id: qrcodeId,
    });

    return response.data;
  } catch (error) {
    console.error(
      "Scan Shop Error:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const getVolunteerById = async (volunteerId) => {
  try {
    const response = await axios.get(`${BASE_URL}/scan/volunteer/${volunteerId}`, {
      headers: {
        Accept: "application/json",
      },
    });

    console.log("Volunteer Data:", response.data);
    return response.data;
  } catch (error) {
    console.error("getVolunteerById Error:", error.response?.data || error.message);
    throw error;
  }
};

// Example:
/*
await submitUserForm({
  type_of_shop: "Grocery",
  dustbin_available: true,
  hand_sanitizer_available: true,
  use_plastic_bags: false,
  rating: 4,
  shop_owner_id: 12,
});
*/



